'use strict';

angular.module('amexReconciliationApp')
  .directive('previouslyUsedAccountingFieldValuesDropdown',
    function () {
      var medium_screen_size = 992;
      var large_row = 6;
      var end_of_large_row = 5;
      var small_row = 2;
      var end_of_small_row = 1;

      function isFieldAtEndOfRow($window, schema) {
        var position = schema.position;

        if ($window.innerWidth > medium_screen_size) {
          if (position % large_row === end_of_large_row) {
            return true;
          }
        }
        else {
          if (position % small_row === end_of_small_row) {
            return true;
          }
        }

        return false;
      }

      return {
        restrict: 'E',
        templateUrl: 'scripts/views/directives/previously-used-accounting-field-values-dropdown.html',
        scope: {},
        bindToController: {
          allocation: '<',
          allocationIndex: '<',
          schema: '=',
          field: '=',
          onFieldValueChanged: '&',
          isDropdownOpen: '<',
          clearLowerComboValues: '&'
        },
        controller: function ($scope,
                              $window,
                              SiteConfigModel,
                              AccountingCodeValueRepository,
                              PreviouslyUsedAccountingFieldValuesModel) {
          var self = this;
          var linkedComboFields;

          self.isRight = isFieldAtEndOfRow($window, self.schema);
          self.previousFieldValues = [];

          self.$onInit = function() {
            linkedComboFields = getLinkedComboFieldValues();
            updatePreviousFieldValues(PreviouslyUsedAccountingFieldValuesModel.previouslyUsedAccountingFieldValues());
          };

          self.$onChanges = function() {
            if (haveAnyFieldValuesChanged()) {
              self.previousFieldValues = [];
              linkedComboFields = getLinkedComboFieldValues();
              updatePreviousFieldValues(PreviouslyUsedAccountingFieldValuesModel.previouslyUsedAccountingFieldValues());
            }
          };

          self.selectPreviousFieldValue = function(previousFieldValue) {
            if (self.field.value === previousFieldValue.value) {
              return;
            }

            self.field.value = previousFieldValue.value;
            self.onFieldValueChanged();
            self.clearLowerComboValues({index: self.allocationIndex,position: self.field.position});
          };
          
          self.deletePreviouslyUsedAccountingFieldValues = PreviouslyUsedAccountingFieldValuesModel.deletePreviouslyUsedAccountingFieldValues;

          function updatePreviousFieldValues(previousFieldValues) {
            var allPreviousFieldValues = _.filter(previousFieldValues, { position: self.schema.position });
            var comboValidate = self.schema.validationIndicator === 'C';
            if (comboValidate) {
              filterPreviousValuesWithComboValidation(allPreviousFieldValues).then(function(filteredCodes) {
                self.previousFieldValues = filteredCodes;
              });
            } else {
              self.previousFieldValues = allPreviousFieldValues;
            }
          }

          function filterPreviousValuesWithComboValidation(allPreviousFieldValues) {
            var previousValues = getPreviousValues(allPreviousFieldValues);
            var linkedComboValues = getLinkedComboFieldValues();
            var linkedComboStrings = getLinkedComboFieldStrings(_.concat(previousValues,linkedComboValues));
            var params = {companyId: SiteConfigModel.companyId(),
              siteNumber: SiteConfigModel.siteNumber(),
              schema: self.schema,
              searchString: '',
              comboPositions: linkedComboStrings.positions,
              comboValues: linkedComboStrings.values
            };

            return AccountingCodeValueRepository.getAccountingCodes(params).then(function (codes) {
              var codeValues = _.map(codes,function(o) {return o.value;});
              return _.filter(allPreviousFieldValues, function(previousValue) {
                return _.includes(codeValues,previousValue.value);
              });
            });
          }

          function getPreviousValues(allPreviousFieldValues) {
            return _.map(allPreviousFieldValues, function(o) {
              return {
                comboPosition: _.get(self.schema, 'validationComboPosition', 0),
                position: _.get(self.schema, 'position',0),
                value: o.value};
            });
          }

          function getLinkedComboFieldValues() {
            var schemas = SiteConfigModel.getAccountingFieldSchemas();
            var linkedComboFields = [];
            if (self.schema.validationComboId !== 0) {
              linkedComboFields = _.map(_.filter(schemas, function(o) {
                return (o.validationComboId === self.schema.validationComboId &&
                o.displayIndex < self.schema.displayIndex);
              }), function(filteredSchema) {
                return {
                  comboPosition: _.get(filteredSchema, 'validationComboPosition', 0),
                  position: _.get(filteredSchema, 'position',0),
                  value: _.get(_.find(self.allocation.accountingFieldValues, ['position', filteredSchema.position]), 'value', '')
                };
              });
            }
            return linkedComboFields;
          }

          function getLinkedComboFieldStrings(linkedComboFields) {
            var positions = 'start,';
            var values = 'start,';
            _.forEach(linkedComboFields, function(o) {
              positions += o.comboPosition.toString() + ',';
              values += o.value + ',';
            });
            return {positions: positions+'end', values: values+'end'};
          }

          function haveAnyFieldValuesChanged() {
            return _.some(linkedComboFields, function(comboField) {
              var valueOnAllocation = _.get(_.find(self.allocation.accountingFieldValues, ['position', comboField.position]), 'value', 0);
              return comboField.value != valueOnAllocation;
            });
          }
          
          PreviouslyUsedAccountingFieldValuesModel
            .onPreviouslyUsedAccountingFieldValuesChanged($scope, updatePreviousFieldValues);
        },
        controllerAs: '$ctrl'
      };
    });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/previouslyUsedAccountingFieldValuesDropdown.js
// module id = 530
// module chunks = 0